import { render } from "./SettingsLog.vue?vue&type=template&id=7138429a"
import script from "./SettingsLog.vue?vue&type=script&lang=js"
export * from "./SettingsLog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__